import { ReactNode } from 'react';
import { Flex, FlexProps } from '@blockanalitica/ui';
import { NavLink as RouterNavLink } from 'react-router';
import styled, { css } from 'styled-components';

const Wrapper = styled(Flex)`
  position: relative;
  cursor: pointer;
`;

export type NavigationRoute = {
  title: string;
  url: string;
  icon?: ReactNode;
  end?: boolean;
};

export interface NavigationProps extends FlexProps {
  routes: NavigationRoute[];
}

const NavLink = styled(RouterNavLink)`
  text-decoration: none;
  display: flex;
  align-items: center;
  cursor: pointer;

  ${(props) => css`
    gap: ${props.theme.space['2xs']};
    color: ${props.theme.colors.text};

    &:hover {
      color: ${props.theme.colors.linkHover};
    }

    &.active {
      position: relative;
      color: ${props.theme.colors.primary};
    }
  `}
`;

export default function Navigation({ routes, ...rest }: NavigationProps) {
  return (
    <Wrapper alignItems="center" gap="s" {...rest}>
      {routes.map((route) => (
        <NavLink key={route.url} to={route.url} end={route.end} role="button">
          {route.icon} {route.title}
        </NavLink>
      ))}
    </Wrapper>
  );
}
